import { CookieNameEnum } from "../constants/cookie-names"
import Merchant from "../interfaces/merchant/merchant"
import { ReadonlyRequestCookies } from "next/dist/server/web/spec-extension/adapters/request-cookies"
import { getCookie } from "cookies-next"

function parseMerchantSummaryCookie(value?: string): Merchant.ResponseSummary | undefined {
    if (!value)
        return undefined

    try {
        const decoded = tryDecodeURIComponent(value)
        return JSON.parse(decoded) as Merchant.ResponseSummary
    }
    catch {
        return undefined
    }
}

function tryDecodeURIComponent(str: string): string {
    try {
        const decoded = decodeURIComponent(str)
        if (decoded !== str)
            return decoded
        return str
    }
    catch {
        return str
    }
}

export const getMerchantSummaryCookieServer = (cookie: ReadonlyRequestCookies) => {
    const value = cookie.get(CookieNameEnum.MerchantSummary)?.value
    return parseMerchantSummaryCookie(value)
}

export const getMerchantSummaryCookieClient = () => {
    const value = getCookie(CookieNameEnum.MerchantSummary)
    return parseMerchantSummaryCookie(typeof value === "string" ? value : undefined)
}